import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useEmployeeEdit from "./useEmployeeEdit";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { dataURLtoFile } from "utils/helper";
import { useSelector } from "react-redux";

const toInitialValues = (initialValues = {}) => {
  let dateOfBirth = initialValues?.dateOfBirth
    ? dayjs(initialValues?.dateOfBirth)
    : null;
  let workPermitIssueDate = initialValues?.workPermitIssueDate
    ? dayjs(initialValues?.workPermitIssueDate)
    : null;
  let workPermitExpireDate = initialValues?.workPermitExpireDate
    ? dayjs(initialValues?.workPermitIssueDate)
    : null;
  const date2 = dayjs();
  let years = date2.diff(dateOfBirth, 'year');

  return {
    ...initialValues,
    age: years,
    titleId: initialValues?.title?.id,
    raceId: initialValues?.race?.id,
    genderId: initialValues?.gender?.id,
    dateOfBirth: dateOfBirth,
    nationalityId: initialValues?.nationality?.id,
    religionId: initialValues?.religion?.id,
    maritalStatusId: initialValues?.maritalStatus?.id,
    militaryStatusId: initialValues?.militaryStatus?.id,
    genderCode: initialValues?.gender?.nameEn.toUpperCase(),
    workPermitNo: initialValues?.workPermitNo,
    workPermitIssueDate: workPermitIssueDate,
    workPermitExpireDate: workPermitExpireDate,
    bloodGroupId: initialValues?.bloodGroup?.id,
    employeeImage: initialValues?.employeeImage
      ? dataURLtoFile(
        "data:image/png;base64, " + initialValues?.employeeImage,
        "example.png"
      )
      : null,

  };
};

function useEmployeeGeneralInfoProfile(nev = false) {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState("en");
  const [generalInfo, setGeneralInfo] = useState({});
  let { id } = useParams();
  let employeeId = id;

  const [isVisible, setIsVisible] = useState(false);

  const { getEmployee, getEmployeeOnEdit, isLoading } = useEmployeeEdit(nev)
  const currentEmployee = useSelector(
    (state) => state.employee.currentEmployee
  );
  const currentEmployeeOnEdit = useSelector(
    (state) => state.employee.currentEmployeeOnEdit
  );

  const handleToggleVisibility = () => {
    setIsVisible(prev => {
      const updatedVisible = !prev;
      getEmployeeOnEdit({ employeeId, visible: updatedVisible, edit: false });
      return updatedVisible;
    });
  };

  const initialValues = useMemo(() => {
    let formInitialValues;
    if (isVisible) {
      formInitialValues = toInitialValues(currentEmployeeOnEdit);
    } else {
      formInitialValues = toInitialValues(currentEmployee);
    }
    setGeneralInfo(formInitialValues)
    return formInitialValues;
  }, [currentEmployee, currentEmployeeOnEdit, isVisible]);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);

  return {
    setIsVisible,
    isVisible,
    getEmployee,
    isLoading,
    handleToggleVisibility,
    generalInfo
  };
}

export default useEmployeeGeneralInfoProfile;
